import Cookie from "@universidade-franciscana/componente-front/src/utils/cookies.js"
import apiAutenticacaoComponente from "@universidade-franciscana/componente-front/src/services/api/autenticacao.js"

function anexarTokenAtual(config) {
  config.headers.Authorization = `Bearer ${Cookie.get("token")}`

  return config
}

export function aplicarInterceptorToken(instance) {
  instance.interceptors.request.use(anexarTokenAtual)

  return instance
}

/**
 * A instância "autenticacao" do componente-front usa um header Authorization fixado
 * na criação do axios (não é atualizado após renovação de token). Ela é usada
 * internamente na verificação de permissão do guard de rota (router/index.js) e
 * acaba gerando 403 para usuários com permissão válida após o token ser renovado.
 * Aplicamos aqui o mesmo interceptor enquanto a correção equivalente não é
 * publicada no pacote componente-front (caminho src/services/api/interceptor-token.js).
 */
aplicarInterceptorToken(apiAutenticacaoComponente)
